import * as React from "react";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";

import { styled } from "@material-ui/core/styles";
import { Auth } from "aws-amplify";
import { validateAdminUser } from "../../sdk/auth";
import { rudderIdentify, rudderTrack } from "../../utils/rudderstack/init";

const LoginContainer = styled(Paper)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  padding: "1em",
  textAlign: "center",
  width: "300px",
});

interface LoginPageProps {
  loggedIn: (data: string) => void;
}

export const LoginPage: React.FC<LoginPageProps> = (props) => {
  const [user, setUser] = React.useState("");
  const [password, setPassword] = React.useState("");

  const handleSubmit = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    if (!(user && password)) {
      return;
    }

    try {
      const data = await Auth.signIn(user, password);
  
      await rudderIdentify(data.attributes.sub as string, {
        email: data.attributes.email,
        name: `${data.attributes.given_name} ${data.attributes.family_name}`,
      });
  
      await rudderTrack("Backoffice Signed In", {
        email: data.attributes.email,
        name: `${data.attributes.given_name} ${data.attributes.family_name}`,
      });
  
      validateAdminUser(data);
      setUser("");
      setPassword("");


      if (window.analytics) {
        window.analytics.identify(data.attributes.sub as string, {
          id: data.attributes.sub,
          username: data.username,
          email: data.attributes.email,
          family_name: data.attributes.family_name,
          given_name: data.attributes.given_name,
        });

        window.analytics.track("Backoffice Signed In", {
          id: data.attributes.sub,
          username: data.username,
          email: data.attributes.email,
          family_name: data.attributes.family_name,
          given_name: data.attributes.given_name,
        });
      }

      props.loggedIn(data.attributes.sub);
    } catch {
      // pass
    }

    return false;
  };

  return (
    <LoginContainer elevation={1}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              placeholder="User"
              name="username"
              type="email"
              value={user}
              onChange={(ev) => setUser(ev.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              placeholder="Password"
              name="password"
              type="password"
              value={password}
              onChange={(ev) => setPassword(ev.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <Button type="submit">Login</Button>
          </Grid>
        </Grid>
      </form>
    </LoginContainer>
  );
};
